import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Editor, toHTML } from 'ngx-editor';
import { TestService } from 'src/app/services/test.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-chaside-texts',
  templateUrl: './chaside-texts.component.html',
  styleUrls: ['./chaside-texts.component.css']
})
export class ChasideTextsComponent implements OnInit {
  @ViewChild('text1') text1: ElementRef;
  @ViewChild('text2') text2: ElementRef;

  public editor:Editor;
  public html;
  public instructionSelected = false;


  public editor2:Editor;
  public html2;
  public reportSelected = false;
  public texts={

    chasideInstructions:"",
    chasideReportText:"",

    _id:"123456789987"
  };
  constructor(private testService: TestService) { 
    this.testService.getTexts().subscribe(
      resp=>{
        if (resp) {
          this.texts.chasideInstructions = resp.chasideInstructions;
          this.texts.chasideReportText = resp.chasideReportText;
          this.html = this.texts.chasideInstructions;
          this.html2 = this.texts.chasideReportText;
          this.text1.nativeElement.innerHTML = this.html;
          this.text2.nativeElement.innerHTML = this.html2;

      }

      },
      err=>console.log(err)
    )
  }

  ngOnInit(): void {
  }

  saveHtml(){
    var html;
    if (this.html.type == "doc"){
      html = toHTML(this.html);
    }else{
      html = this.html;
    }

    this.texts.chasideInstructions = html;

    let obj = {
      chasideInstructions:this.texts.chasideInstructions,
      chasideReportText:this.texts.chasideReportText,
      _id:this.texts._id
    }

    this.testService.updateTexts(obj).subscribe(
      resp=>{
        Swal.fire('Actualizado');
      },
      err=>console.log(err)
    )

  }

  saveHtml2(){
    var html;
    if (this.html2.type == "doc"){
      html = toHTML(this.html2);
    }else{
      html = this.html2;
    }

    this.texts.chasideReportText = html;

    let obj = {
      chasideInstructions:this.texts.chasideInstructions,
      chasideReportText:this.texts.chasideReportText,
      _id:this.texts._id
    }
    this.testService.updateTexts(obj).subscribe(
      resp=>{
        Swal.fire('Actualizado');
      },
      err=>console.log(err)
    )

  }

  editInstructions(){
    if(this.editor2) this.editor2.destroy();
      this.reportSelected = false;
      setTimeout(()=>{
        this.text2.nativeElement.innerHTML = this.html2;
      }, 500)
      this.instructionSelected = true;
      this.editor = new Editor();
  }

  editReport(){
    if(this.editor) this.editor.destroy();
    this.instructionSelected = false;
    setTimeout(()=>{
      this.text1.nativeElement.innerHTML = this.html;
    }, 500);
    this.reportSelected = true;
    this.editor2 = new Editor();
  }

}
